module.exports = __webpack_public_path__ + "static/gatsby-icon-3207180e6b7c43f883a8a1c0d03d71b5.png";